module.exports = __webpack_public_path__ + "img/codepen.bd759105.svg";